import {createSlice} from '@reduxjs/toolkit'
import { LOGIN_URL, LOGOUT_URL, REQUEST_STATUS, ROUTE_PATH, SEGUE_NAME } from '../../app/constants'
import { saveSegueDetails } from './primaryAgencyApplicationSlice'

const nsLoginState = () => ({
    "mortgage-lender-licence":{
        navigation:{
            next: ROUTE_PATH.ML_CHOOSE_NEW_COMPLIANCE_OFFICER
        }
    },
    "collection-agency" : {
        header : "Apply for a collection agency licence",
        headerRenewal : "Renew collection agency licence",
        text : [
            "Create an account or sign in with an existing account to apply for a Collection Agency Licence."
        ],
        textRenewal : [
            "Create an account or sign in with an existing account to renew Collection Agency Licence."
        ],
        navigation : {
            next : ROUTE_PATH.WELCOME
        },
        navigationRenewal : {
            next : ROUTE_PATH.RJSC_SEARCH
        }
    },
    "debt-management-agency" : {
        header : "Apply for a debt management agency licence",
        headerRenewal : "Renew debt management agency licence",
        text : [
            "Create an account or sign in with an existing account to apply for a Debt Management Agency Licence."
        ],
        textRenewal : [
            "Create an account or sign in with an existing account to renew Debt Management Agency Licence."
        ],
        navigation : {
            next : ROUTE_PATH.WELCOME
        },
        navigationRenewal : {
            next : ROUTE_PATH.RJSC_SEARCH
        }
    },
    "collector" : {
        header : "Apply for a collector licence",
        headerRenewal : "Renew collector licence",
        text : [
            "Create an account or sign in with an existing account to apply for a Collector Licence."
        ],
        textRenewal : [
            "Create an account or sign in with an existing account to renew Collector Licence."
        ],
        navigation : {
            next : ROUTE_PATH.COLLECTOR_BEFORE_START
        }
    },
    "principal-broker": { 
        header : "Apply for a principal broker",
        headerRenewal : "Renew principal broker licence",
        text : [
            "Create an account or sign in with an existing account to apply for a Principal Broker."
        ],
        textRenewal : [
            "Create an account or sign in with an existing account to renew Principal Broker."
        ],
        navigation : {
            next : ROUTE_PATH.WELCOME
        }
    },
    "compliance-officer": { 
        header : "Apply for a compliance officer",
        headerRenewal : "Renew compliance officer licence",
        text : [
            "Create an account or sign in with an existing account to apply for a Compliance Officer."
        ],
        textRenewal : [
            "Create an account or sign in with an existing account to renew Compliance Officer."
        ],
        navigation : {
            next : ROUTE_PATH.WELCOME
        }
    },
    header : "Apply for a collection agency licence",
    text : [
        "Create an account or sign in with an existing account to apply for a Collection Agency Licence."
    ],
    navigation : {
        next : ROUTE_PATH.WELCOME
    }
})

const nsLoginSlice = createSlice({
    name: 'nsLogin',
    initialState : nsLoginState(),
    reducers : {
        setLoginStatus(state, action) {
            state.loginStatus = action.payload
        },
        setLogoutStatus(state, action) {
            state.logoutStatus = action.payload
        },
        setLoginExpired(state, action) { 
            state.loginExpired = action.payload
        }
    }
})

export const { 
    setLoginStatus , 
    setLogoutStatus,
    setLoginExpired
} = nsLoginSlice.actions

export const startNSLogin = () => async (dispatch) => {
    dispatch(setLoginStatus(REQUEST_STATUS.IN_PROGRESS))
    return new Promise(resolve => setTimeout(resolve, 100))
                .then(() => {
                    window.location.assign(LOGIN_URL)
                })
}

export const startNSLogout = (applicationType, applicationMode) => async (dispatch) => { 
    dispatch(setLogoutStatus(REQUEST_STATUS.IN_PROGRESS))
    
    dispatch(saveSegueDetails({
        name : SEGUE_NAME.LOGOUT,
        applicationType,
        applicationMode
    }))

    return new Promise(resolve => setTimeout(resolve, 100))
                .then(() => {
                    window.location.assign(LOGOUT_URL)
                })

}

export default nsLoginSlice.reducer
